import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { IChatCrypt, IChatCryptMessage } from '../_interfaces';

@Injectable()
export class ChatCryptService {
  constructor(private http: HttpService) {
  }

  encrypt(nursingHomeId: number, chatCrypt: IChatCryptMessage): Observable<IChatCrypt> {
    return this.http.post<IChatCrypt>('/api/v2/pro/nursing-homes/' + nursingHomeId + '/chats/encrypt', chatCrypt);
  }

  decrypt(nursingHomeId: number, params: IChatCrypt[]): Observable<IChatCrypt[]> {
    return this.http.post<IChatCrypt[]>('/api/v2/pro/nursing-homes/' + nursingHomeId + '/chats/decrypt', params);
  }
}
